import { useState, useEffect } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../../config/axios';
import { message } from 'antd';
import Globals from '../../../config/globals';
import evitePng from '../../../img/evite_thumbnail.png';
import d2pLogo from '../../../img/D2P-logo.png';
import htmlPng from '../../../img/Thumb_HTML.PNG';
import jpgPng from '../../../img/Thumb_JPG.PNG';
import pdfPng from '../../../img/Thumb_PDF.PNG';
import thumbVideo from '../../../img/Thumb_Video.PNG';
import placeholderImg from '../../../img/sample_placeholder.png';
import { toast, confirm } from '@rickylandino/react-messages';

export function D2PVideoSlider({ showPane, showCode, hidePane }) {

    const [showPaneState, setShowPaneState] = useState(showPane);

    useEffect(() => {
        setShowPaneState(showPane);
    }, [showPane])


    // Loading state for each download button
    const [loadingBtn, setLoadingBtn] = useState({});

    const setLoading = (label, value) => {
        setLoadingBtn(prev => ({ ...prev, [label]: value }));
    };

    // Download D2P Logo handler
    const downloadD2PLogo = () => {
        setLoading('D2P Logo', true);
        try {
            // Create a link and trigger download
            const link = document.createElement('a');
            link.href = d2pLogo;
            link.setAttribute('download', 'D2P-logo.png');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } finally {
            setLoading('D2P Logo', false);
        }
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText('https://www.youtube.com/watch?v=F0itEpw1qU4');

            toast.success("Video link successfully copied to your clipboard.");
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    return (
        <SlidingPane
            className='some-custom-class'
            overlayClassName='showCard'
            isOpen={showPaneState}
            title='D2P Promotional YouTube Video'
            onRequestClose={hidePane}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
            width="60%"
        >
            <div className="slide-pane-body scrollableDiv">
                <div className="card bg-light text-center border-0 shadow-sm d-flex flex-row" style={{ marginBottom: '0.25rem' }}>
                    <div className=" p-3 d-flex flex-column align-items-center" style={{ minWidth: 200, maxWidth: 220 }}>
{/*                        <div className="fw-bold mb-2" style={{ fontSize: 'small' }}>D2P Video Link</div>*/}
                        <img src={thumbVideo} alt="D2P Video" style={{ width: 164, height: 109, objectFit: 'contain', marginBottom: 8 }} />
                        <button
                            className="btn btn-warning btn-sm w-100"
                            onClick={copyToClipboard}
                        >
                            Copy Video Link
                        </button>
                    </div>
                    <div className="align-self-center p-2"> {/* reduced padding */}
                        <div style={{ fontSize: '15px', textAlign: 'left' }}>
                            <div style={{ marginBottom: 5 }}> {/* reduced spacing */}
                                <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                    A short promotional video highlighting the Design-2-Part show experience.
                                </p>

                                <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                    <strong>How to use:</strong>
                                </p>

                                <ul style={{ marginTop: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Copy the YouTube video link
                                    </li>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Embed it on your website or landing page
                                    </li>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Include the link in email campaigns
                                    </li>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Share on social media to build excitement
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn btn-primary btn-lg margin-left-15" onClick={hidePane}>Close</button>
                </div>
            </div>
        </SlidingPane>
    );
}